angular
    .module('logbook')
    .directive('customHtmlTag', ['$compile', function($compile)
    {
        return {
            restrict: 'A',
            scope: {
                customAttributes: '=',
                parentScope: '='
            },
            link: function(scope, element, attributes)
            {
                if (typeof attributes.customHtmlTag !== 'string') return;

                var newAttributes = (scope.customAttributes || []).map(function(value) { return value.name + '=' + '"' + value.value + '"' }).join(' ');
                var newElement = angular.element('<' + attributes.customHtmlTag + ' ' + newAttributes + '></' + attributes.customHtmlTag + '>');

                element.replaceWith($compile(newElement)(scope.parentScope || scope.$parent));
                scope.$destroy();
            }
        }
    }]);